/**
 * Shared engine-output key classification for the two EngineAuditPanel surfaces
 * (Analysis stage + Finalize). Only money keys may render with "$"; score keys are
 * unit-less and must render as plain numbers.
 */

export function isMoneyKey(key: string): boolean {
  return (
    key === 'final_claim_amount' ||
    key === 'rcv_total' ||
    key === 'total_loss' ||
    key === 'recommended_recovery' ||
    key === 'total_deductions' ||
    key === 'mitigation_credit' ||
    key === 'recoverable_depreciation' ||
    key.endsWith('_amount') ||
    key.endsWith('_total') ||
    key.endsWith('_loss')
  );
}

export function isScoreKey(key: string): boolean {
  return (
    key === 'confidence_score' ||
    key === 'case_strength' ||
    key.endsWith('_score')
  );
}

/** Headline-key priority. `final_score` (the case_strength engine's headline) ranks ahead of
 * the `confidence_score` sub-score. */
export const OUTPUT_KEY_PRIORITY: readonly string[] = [
  'final_claim_amount',
  'total_loss',
  'recommended_recovery',
  'rcv_total',
  'settlement_range',
  'final_score',
  'confidence_score',
  'case_strength',
  'status',
  'result',
];
